import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CheckoutBankUserNewComponent } from './checkout-bank-user-new.component';

@Component({
  selector: 'checkout-bank-user-edit',
  templateUrl: './checkout-bank-user-edit.component.html',
})
export class CheckoutBankUserEditComponent extends CheckoutBankUserNewComponent implements OnInit {
  constructor(protected router: Router, protected location: Location) {
    super(router, location);
  }

  ngOnInit() {
    this.isNew = false;
  }
}
